import { LOGGED_IN_ACTION, UPDATE_AUTH_TOKEN, CLEAR_AUTH, SET_TEAM, UPDATE_DATA, UPDATE_GLOBAL_STATE, DELETE_STATUS } from './actions'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as permissions } from "react-redux-permissions"

const initialState = {
    global: {
        authToken: '',
        refreshToken: '',
        user: null,
        activePageComponent: 'visit-list',
        visits: {},
        recipients: {},
        currentVisit: {},
        currentRecipient: {},
        status_list: []
    },
    sync_queue: {
        queue: []
    }
}

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_IN_ACTION:
        case UPDATE_AUTH_TOKEN:
        case UPDATE_DATA:
        case UPDATE_GLOBAL_STATE:
        case SET_TEAM:
            return {
                ...state,
                global: {
                    ...state.global,
                    ...action.payload,
                }
            }
        // case ADD_SESSION_TO_CURRENT_VISIT:
        //     throw 'Revisa esto mijo'
        //     state.global.currentVisit.visit_id.note_session_details_ids[JSON.stringify(action.payload)] = [action.payload]
        //     // return {
        //     //     ...state,
        //     //     global: {
        //     //         ...state.global,
        //     //         ...action.payload,
        //     //     }
        //     // }
        //     break
        case DELETE_STATUS:
            const status_list = [].concat(state.global.status_list).filter(x => x.id !== action.payload.id)
            return {
                ...state,
                global: {
                    ...state.global,
                    status_list
                }
            }
        case CLEAR_AUTH:
            return {
                ...state,
                global: {
                    authToken: '',
                    refreshToken: '',
                    user: null
                }
            }
        default:
            // console.info('Action not recognized: ' + action.type)
            break
    }
    return state
}

const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    permissions,
    app: appReducer,
})

export default rootReducer